import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { compare } from 'fast-json-patch';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';
import { JobUnassignedReasonService } from '../../services';
import { IJobUnassignedReason } from '../../interfaces/job-assignment';

@Component({
  selector: 'job-unassigned-reasons',
  templateUrl: './job-unassigned-reasons.component.html',
  styleUrls: ['./job-unassigned-reasons.component.scss'],
})
export class JobUnassignedReasonsComponent implements OnInit {
  jobUnassignedReasons: IJobUnassignedReason[];
  showEditReason: boolean = false;
  reasonForm: UntypedFormGroup;
  saving: boolean = false;
  blameName: string[] = [];
  selectedReason: IJobUnassignedReason;
  state: any;

  public blameReasons = {
    VME: 1,
    Supplier: 2,
    Customer: 3,
    None: 4,
  };

  public blameButtons = [];

  constructor(
    public jobUnassignedService: JobUnassignedReasonService,
    public messageService: MessageService,
  ) {}

  ngOnInit() {
    Object.keys(this.blameReasons).forEach((x) => {
      this.blameButtons.push({ value: this.blameReasons[x], label: x });
      this.blameName[this.blameReasons[x]] = x;
    });

    console.log('BB', this.blameReasons);

    this.initForm();
    this.getJobUnassignedReasons();
  }

  getJobUnassignedReasons() {
    this.jobUnassignedService.getReasons({ component: 'job-unassigned-reasons' }).then((result) => {
      this.jobUnassignedReasons = result;
    });
  }

  initForm() {
    this.reasonForm = new UntypedFormGroup({
      id: new UntypedFormControl(null),
      code: new UntypedFormControl(null),
      description: new UntypedFormControl(null),
      isActive: new UntypedFormControl(true),
      blame: new UntypedFormControl(4),
      weight: new UntypedFormControl(1),
    });
  }

  get f() {
    return this.reasonForm.controls;
  }

  addReason() {
    this.initForm();
    this.showEditReason = true;
  }

  async saveReason() {
    this.createUpdateReason().then(() => {
      this.saving = false;
      this.showEditReason = false;
      this.getJobUnassignedReasons();
    });
  }

  async createUpdateReason() {
    let f = this.reasonForm.value;
    this.saving = true;

    let saveObject = <IJobUnassignedReason>{
      id: f.id,
      code: f.code,
      description: f.description,
      isActive: f.isActive,
      blame: f.blame,
      weight: f.weight,
    };

    if (f.id == null) {
      await this.jobUnassignedService
        .createReason(saveObject)
        .then(() => {})
        .catch((err) => {
          this.messageService.add(
            Message.Error(
              'An error occurred creating the reason. Is it a duplicate ?',
              'Create Error',
            ),
          );
        });
    } else {
      let patch = compare({}, saveObject);

      await this.jobUnassignedService
        .patchReason(f.id, patch)
        .then(() => {})
        .catch((err) => {
          this.messageService.add(
            Message.Error(
              'An error occurred updating the reason. Is it a duplicate ?',
              'Create Error',
            ),
          );
        });
    }
  }

  editReason() {
    this.reasonForm.patchValue(this.selectedReason);
    this.showEditReason = true;
  }

  deleteReason() {
    const patch = compare({}, { isActive: false });
    this.jobUnassignedService.patchReason(this.selectedReason.id, patch).then(() => {
      this.getJobUnassignedReasons();
    });
  }

  reasonChosen(event: any) {}
}
